<template>
  <div class="rt-product-item">
    <div class="__left">
      <div
        v-if="showPicture"
        class="picture-exist"
      >
        <img :src="imgSrc || defaultPicture" />
      </div>
    </div>
    <div class="__right">
      <slot name="title">
        <div class="title">
          {{ title }}
          <!-- 资生堂 随肌应变气垫粉底液 N2 13g（粉盒+粉芯 粉调白皙色 持久不脱 -->
        </div>
      </slot>
      <slot name="sub-title">
        <div class="sub-title">
          {{ subTitle }}
          <!-- DELHJXJZ1111 -->
        </div>
      </slot>
      <slot class="tag">
        <div class="tag">
          <rt-tag
            v-for="(tag, index) in tagList"
            :key="index"
            :color-type="tag.colorType || 'warning'"
          >
            {{ tag.text }}
          </rt-tag>
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
// import defaultPicture from '../../assets/imgs/product-empty.png';
import RtTag from '../tag/rtTag.vue';
export default {
  name: 'RtProductItem',
  components: { RtTag },
  props: {
    imgSrc: String,
    title: String,
    subTitle: String,
    tagList: Array,
    showPicture: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // testTag:[{
      //   text:'库存较少',
      //   colorType:'warning'
      // },
      // {
      //   text:'限量出售',
      //   colorType:'normal'
      // },
      // ],
      defaultPicture: require('../../assets/imgs/product-empty.png')
    };
  },
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// rtProductItem.vue?4265a5e8